export default __webpack_public_path__ + "static/media/home-finance-about-img-02.01346658.jpg";